import baseScmService from 'services/baseScmService';

const academyScheduleService = baseScmService.injectEndpoints({
  endpoints: (build) => ({
    getAcademySchedules: build.query({
      query: () => ({
        url: `/academy-schedules`,
      }),
      keepUnusedDataFor: 60 * 60, // In seconds (Caching for an hour)
    }),
  }),
  overrideExisting: false,
});

export const { useGetAcademySchedulesQuery } = academyScheduleService;

export default academyScheduleService;
